import React from "react";
import { Provider } from "react-redux";
import { CssBaseline } from "@mui/material";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { store } from './AppRedux/store';
import Theme from "./Theme";
import ThemeSetup from "./Theme/themeOptions";
import { UILibraryThemeProvider } from '@zimyo/ui';
import './style.scss';
import ManageProvider from "./Providers/manage-provider";
import "@zimyo/manage/style.css";


const App = () => {
  return (
    <UILibraryThemeProvider>
    <Provider store={store}>
      <ManageProvider>
        <ThemeSetup>
          <CssBaseline />
          <BrowserRouter basename="/">
            <Switch>
              <Route path="/" component={Theme} />
            </Switch>
          </BrowserRouter>
        </ThemeSetup>
      </ManageProvider>
    </Provider>
    </UILibraryThemeProvider>
  )
};

export default App;